import { Button, Input, Space } from "antd";
import { useTableSearch } from "./searchContext";
import { SearchOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";
import { useState } from "react";

export const SearchBar = ({
  selectedKeys,
  confirm,
  clearFilters,
  close,
  dataIndex,
}: Omit<FilterDropdownProps, "prefixCls" | "visible"> & {
  dataIndex?: string;
}) => {
  const { handleSearch, searchedInput, handleReset } = useTableSearch();
  const [localSearchText, setLocalSearchText] = useState("");
  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchedInput}
        placeholder={`Search ${dataIndex}`}
        value={localSearchText}
        onChange={(e) => setLocalSearchText(e.target.value)}
        onPressEnter={() => handleSearch(localSearchText, confirm, dataIndex)}
        style={{ marginBottom: 8, display: "block" }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleSearch(localSearchText, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => {
            setLocalSearchText("");
            clearFilters && handleReset(clearFilters);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          Fechar
        </Button>
      </Space>
    </div>
  );
};
